/* eslint-disable */
import React from 'react';
import ReactDOM from 'react-dom';
import Root from 'Root';
import { i18n } from 'element-react';
import locale from 'element-react/src/locale/lang/ko';

i18n.use(locale);

import 'styles/main.scss';
import 'element-theme-default';
import 'lib/localCart';
import storage, { keys } from 'lib/storage';
import * as gtmTracker from 'lib/tracking/gtmTracker';

// import registerServiceWorker from './registerServiceWorker';

const render = window.__REDUX_STATE__ ? ReactDOM.hydrate : ReactDOM.render;
const isDev = process.env.NODE_ENV === 'development' || process.env.MODE_ENV === 'staging';

if (typeof window !== 'undefined') {
  render(<Root />, document.getElementById('root'));
}
// registerServiceWorker();

if (!isDev) {
  // GTM Load
  (function(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-KJXF37L');

  // GA4 user_id/속성을 GTM 설정 태그(초기 page_view/session_start) 발동 전에 dataLayer에 넣는다.
  // gtm.js는 async라 현재 동기 실행이 끝난 뒤에 로드되므로, 여기서 동기로 push하면 항상 먼저 들어간다.
  // (로그인 사용자는 localStorage에 저장돼 있어 동기 접근 가능)
  try {
    const storedUser = storage.get(keys.user);
    if (storedUser && storedUser.id) {
      gtmTracker.setUser(storedUser);
    }
  } catch (e) {
    // ignore
  }

  // Clarity Load
  (function(c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function() {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = 'https://www.clarity.ms/tag/' + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, 'clarity', 'script', 'su1br4d3ti');
}



// WEBPACK FOOTER //
// ./src/index.js